import SortAscendingIcon from "@/icons/SortAscendingIcon";
import SortDescendingIcon from "@/icons/SortDescendingIcon";

import { Flex } from "antd";

const NOT_FILLED_OPTION = {
  uuid: "notFilled",
  name: "Не заполнено",
  label: "Не заполнено",
};

const SORT_BY = [
  { value: "name", label: "По названию" },
  { value: "date", label: "По дате создания" },
  { value: "dateEnd", label: "По сроку исполнения" },
];

const SORT_OPTIONS = [
  {
    key: "-created_at",
    value: "-created_at",
    label: (
      <Flex gap={5} align="center">
        <SortDescendingIcon style={{ fontSize: 16 }} />
        Дата создания
      </Flex>
    ),
  },
  {
    key: "created_at",
    value: "created_at",
    label: (
      <Flex gap={5} align="center">
        <SortAscendingIcon style={{ fontSize: 16 }} />
        Дата создания
      </Flex>
    ),
  },
  {
    key: "-due_date",
    value: "-due_date",
    label: (
      <Flex gap={5} align="center">
        <SortDescendingIcon style={{ fontSize: 16 }} />
        Срок исполнения
      </Flex>
    ),
  },
  {
    key: "due_date",
    value: "due_date",
    label: (
      <Flex gap={5} align="center">
        <SortAscendingIcon style={{ fontSize: 16 }} />
        Срок исполнения
      </Flex>
    ),
  },
  {
    key: "-template_code",
    value: "-template_code",
    label: (
      <Flex gap={5} align="center">
        <SortDescendingIcon style={{ fontSize: 16 }} />
        Номер шаблона
      </Flex>
    ),
  },
  {
    key: "template_code",
    value: "template_code",
    label: (
      <Flex gap={5} align="center">
        <SortAscendingIcon style={{ fontSize: 16 }} />
        Номер шаблона
      </Flex>
    ),
  },
  {
    key: "-executor.fullname",
    value: "-executor.fullname",
    label: (
      <Flex gap={5} align="center">
        <SortDescendingIcon style={{ fontSize: 16 }} />
        Исполнитель
      </Flex>
    ),
  },
  {
    key: "executor.fullname",
    value: "executor.fullname",
    label: (
      <Flex gap={5} align="center">
        <SortAscendingIcon style={{ fontSize: 16 }} />
        Исполнитель
      </Flex>
    ),
  },
  {
    key: "-author.fullname",
    value: "-author.fullname",
    label: (
      <Flex gap={5} align="center">
        <SortDescendingIcon style={{ fontSize: 16 }} />
        Автор
      </Flex>
    ),
  },
  {
    key: "author.fullname",
    value: "author.fullname",
    label: (
      <Flex gap={5} align="center">
        <SortAscendingIcon style={{ fontSize: 16 }} />
        Автор
      </Flex>
    ),
  },
  {
    key: "-importance.idx,importance.name",
    value: "-importance.idx,importance.name",
    label: (
      <Flex gap={5} align="center">
        <SortDescendingIcon style={{ fontSize: 16 }} />
        Приоритет
      </Flex>
    ),
  },
  {
    key: "importance.idx,importance.name",
    value: "importance.idx,importance.name",
    label: (
      <Flex gap={5} align="center">
        <SortAscendingIcon style={{ fontSize: 16 }} />
        Приоритет
      </Flex>
    ),
  },
  {
    key: "-is_recurring_template",
    value: "-is_recurring_template",
    label: (
      <Flex gap={5} align="center">
        <SortDescendingIcon style={{ fontSize: 16 }} />
        Повторение
      </Flex>
    ),
  },
  {
    key: "is_recurring_template",
    value: "is_recurring_template",
    label: (
      <Flex gap={5} align="center">
        <SortAscendingIcon style={{ fontSize: 16 }} />
        Повторение
      </Flex>
    ),
  },
];

const USER_ROLES = {
  AUTHOR: "author", // автор задачи
  RESPONSIBLE_EXECUTOR: "responsible_executor", // ответственный исполнитель задачи
  COEXECUTOR: "coexecutor", // соисполнитель задачи
  UNIT_MEMBER: "unit_member", // просто сотрудник РГ, не участвующий в задаче
  UNIT_MANAGER: "unit_manager", // руководитель РГ
  ADMINISTRATOR: "administrator", // администратор организации
  ACCEPTOR: "assignee_acceptor", // приемщик задачи
};

const TEMPLATE_EDIT_ROLES = [USER_ROLES.AUTHOR, USER_ROLES.UNIT_MANAGER];

const LOCAL_STORAGE_KEY = "taskTemplatesTableParams";

export {
  NOT_FILLED_OPTION,
  SORT_BY,
  SORT_OPTIONS,
  LOCAL_STORAGE_KEY,
  USER_ROLES,
  TEMPLATE_EDIT_ROLES,
};
